<template>
  <div class="fixed inset-0 overflow-hidden z-30" aria-labelledby="slide-over-title" role="dialog" aria-modal="true" v-if="visible">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
      <div class="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle min-w-24 w-auto hyy-dialog-modal">
        <div class="pointer-events-auto lg:w-screen" :class="[width, fullscreen]">
          <form class="flex h-fit flex-col overflow-hidden bg-white">
            <div class="flex-1">
              <div class="bg-indigo-700 px-4 pt-3 pb-2">
                <div class="flex items-start justify-between space-x-3">
                  <div class="space-y-1">
                    <h2 class="text-base font-medium text-white" id="slide-over-title">{{ title }}</h2>
                  </div>
                  <div class="flex h-7 items-center">
                    <button @click="() => { $emit('update:visible', false) }" type="button" class="text-white">
                      <span class="sr-only">Close panel</span>
                      <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <slot></slot>
            </div>

            <!-- Action buttons -->
            <div class="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6" v-if="ActionBtnShow">
              <div class="flex justify-end space-x-3">
                <button @click="() => { $emit('update:visible', false) }" type="button" class="rounded-md border border-gray-300 bg-white py-2 px-6 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">取 消</button>
                <button @click="() => { $emit('submit') }" type="button" class="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-6 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">{{submitText}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'xxxx'
    },
    ActionBtnShow: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: 'max-w-lg'
    },
    fullscreen: {
      type: String,
      default: ''
    },
    submitText: {
      type: String,
      default: '提 交'
    }
  },
  data () {
    return {}
  }
}
</script>
